// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-overview[data-v-fe2cb366] {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 500px;
}
.project-overview > div[data-v-fe2cb366] {
  height: 50%;
}
.project-overview-top[data-v-fe2cb366] {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.project-overview-top > div[data-v-fe2cb366] {
  flex: 1;
}
`, "",{"version":3,"sources":["webpack://./src/views/BigDataSoftware/HistoryData/ProjectOverview.vue","webpack://./ProjectOverview.vue"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;ACAF;ADEA;EACE,WAAA;ACAF;ADEA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;ACAF;ADEA;EACE,OAAA;ACAF","sourcesContent":["\n.project-overview {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  height: 500px;\n}\n.project-overview > div {\n  height: 50%;\n}\n.project-overview-top {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n.project-overview-top > div {\n  flex: 1;\n}\n",".project-overview {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  height: 500px;\n}\n.project-overview > div {\n  height: 50%;\n}\n.project-overview-top {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n.project-overview-top > div {\n  flex: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
